export const SUPER_ADMIN = 'ROLE_SUPER_ADMIN';
export const G20_ADMIN = 'ROLE_G20_ADMIN';
export const STORE_ADMIN = 'ROLE_STORE';
